export function validateZip(value, onSuccess, onFailure)
{
    const zipCodesList = window.formZipCodes ?? {};
    const reg = /(^\d{5}$)/;

    const isValid =
        value.length === 5 &&
        reg.test(value) &&
        Object.values(zipCodesList).includes(value);

    if (isValid) {
        if (typeof onSuccess === 'function') {
            onSuccess();
        }
    } else {
        if (typeof onFailure === 'function') {
            onFailure();
        }
    }

    return isValid;
}
